<template>
  <div :class="'image-placeholder image-placeholder--' + ratio">
    <div class="image-placeholder__content">
      <div class="image-placeholder__content__text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4ImagePlaceholder",
  props: {
    text: String,
    ratio: {
      text: String,
      default() {
        return "4-3";
      }
    }
  }
};
</script>
